
export const carouselConfigThemeKey = 'carousel';

export interface CarouselThemeProps {
  arrowButtonColorNormal: string;
  arrowButtonColorHover: string;
  arrowIconColor: string;
  carouselImageHasText: boolean;
}
